import React from 'react';
import styles from './styles.module.scss';
import srcAlertIconWhite from '../alert-icon-white.svg';
import { Link } from 'react-router-dom';
import { announcementsPath } from 'utils/paths';
import enhance from './enhance';

export const AnnouncementAlert = ({
  count,
  importantAnnouncement,
  viewButton,
  iconContainerStyle,
  headerContainerStyle,
  buttonStyle,
  announcementBrand,
}) => (
  <div className={styles.alertContainer}>
    <div className={announcementBrand}>
      <div className={styles.announcementLabel} style={iconContainerStyle}>
        <img
          className={styles.alertIcon}
          alt="announcement"
          src={srcAlertIconWhite}
        />
      </div>
      <div className={styles.announcementBody} style={headerContainerStyle}>
        <div>
          {count} {importantAnnouncement}
        </div>
        <div>
          <Link to={announcementsPath}>
            <button className={styles.viewButton}>{viewButton}</button>
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default enhance(AnnouncementAlert);
